import axios from 'axios'
import toast from '../services/toast'

const baseURL = '/api'
// move the common header for axios here from bootstrap.js
// let token = document.head.querySelector('meta[name="csrf-token"]');
const baseRest =
  axios.create({
    baseURL
    // headers: {
    //   "X-Requested-With": "XMLHttpRequest",
    //   "X-CSRF-TOKEN": token.content
    // }
  })

baseRest.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    const settings = {
      timeOut: 2000,
      closeOnClick: true,
      overlay: true,
      overlayClose: true,
      onClosed: function () {
        window.location = '/login'
        return Promise.reject(error)
      }
    }
    toast.error(
      'Redirecting to login page...',
      'Session Expired',
      'center',
      settings
    )
  } else {
    toast.error(error.response.data.message, 'Error')
    return Promise.reject(error)
  }
})

export default baseRest
